import { createStorageValue } from '@interhyp/platform-storage';
import { z } from 'zod';
import { standaloneAppNamespace } from '../namespaces';
const applicationPrefillSchema = z.object({
    ventureReason: z
        .enum(['KaufBest', 'KaufNeu', 'Bau', 'Umbau', 'Umschuld', 'KapitalB', 'KonsKred'])
        .optional(),
    estateCombiType: z
        .enum(['Wohnung', 'EFH', 'DHH', 'ZFH', 'REH', 'RMH', 'MFH', 'Grund'])
        .optional(),
    estateUtilization: z.enum(['eigen', 'misch', 'fremd']).optional(),
    estateProgress: z.enum(['visited', 'agreement_reached', 'found', 'searching']).optional(),
    buyTimeline: z.number().optional(),
    buildTimeline: z.number().optional(),
    zipVenture: z.string().optional(),
    priceBuilding: z.number().optional(),
    priceLand: z.number().optional(),
    costsBuilding: z.number().optional(),
    equityValue: z.number().optional(),
    marketValue: z.number().optional(),
    desiredLoanAmount: z.number().optional(),
    consumerCreditLoanAmount: z.number().optional(),
    desiredRepayment: z.number().optional(),
    payoutDate: z.string().optional(),
    residualDebt: z.number().optional(),
    brokerCosts: z.enum(['withBrokerCosts', 'withoutBrokerCosts']).optional(),
    brokerCostsPercentage: z.number().optional(),
    consultationType: z.string().optional(),
    branchRequest: z.string().optional(),
    jobStatus: z.string().optional(),
    netSalary: z.number().optional(),
    salutation: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    zip: z.string().optional(),
    emailAddress: z.string().optional(),
    phoneNumber: z.string().optional(),
    preferredProcessor: z.string().optional(),
    proposedDateOrConsultationWishes: z.string().optional(),
    brokerFee: z.number().optional(),
    title: z.string().optional(),
    maturity: z.number().optional(),
});
export const applicationPrefillSessionValues = createStorageValue({
    namespace: standaloneAppNamespace,
    id: Symbol('applicationPrefillValues'),
    schema: applicationPrefillSchema,
    type: 'session',
});
